'use client'

import styles from '@/styles/components/parts/ResearcherModal.module.scss'
import { useCallback, useEffect, useRef } from 'react'

interface Props {
  isOpen?: boolean
  children: React.ReactNode
  onClose?: () => void
  className?: string
  title?: string
}

let openCount = 0

export default function ModalDefault({
  isOpen = false,
  children,
  onClose,
  className,
  title,
}: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const innerRef = useRef<HTMLDivElement>(null)

  useEffect((): void => {
    const dialogElement = dialogRef.current
    if (!dialogElement) {
      return
    }
    if (isOpen) {
      if (dialogElement.hasAttribute('open')) {
        return
      }

      // スクロール防止とレイアウトが崩れないように
      // 既にモーダルを開いているときはそのまま
      if (openCount === 0) {
        document.body.style.top = `-${window.scrollY}px`
        document.body.style.width = '100%'
        document.body.style.position = 'fixed'
        document.body.style.overflowY =
          document.body.scrollHeight > document.body.clientHeight ? 'scroll' : ''
      }
      openCount += 1

      dialogElement.showModal()

      // スクロール位置をリセット (表示されてないと効かない)
      innerRef.current?.scrollTo(0, 0)
    } else {
      if (!dialogElement.hasAttribute('open')) {
        return
      }

      openCount -= 1
      if (openCount === 0) {
        const scrollY = document.body.style.top
        document.body.style.top = ''
        document.body.style.width = ''
        document.body.style.position = ''
        document.body.style.overflowY = ''
        window.scrollTo(0, parseInt(scrollY || '0') * -1)
      }

      dialogElement.close()
    }
  }, [isOpen])

  const handleClickDialog = useCallback((): void => {
    onClose?.()
  }, [onClose])
  const handleClickContent = useCallback((event: React.MouseEvent<HTMLDivElement>): void => {
    // clickイベントの伝搬を止める。
    event.stopPropagation()
  }, [])

  return (
    <>
      <dialog className={`${styles.researcherModal}`} ref={dialogRef} onClick={handleClickDialog}>
        <div className={styles.researcherModal__head} onClick={handleClickContent}>
          {title && (
            <h2 className={`${styles.researcherModal__title} ${className ?? ''}`}>{title}</h2>
          )}
          <button className={styles.researcherModal__close} onClick={handleClickDialog}>
            <span className="icon icon-close icon__researcherModalclose"></span>
          </button>
        </div>
        <div className={styles.researcherModal__inner} onClick={handleClickContent}>
          <div className={styles.researcherModal__regist}>
            <div className={styles.researcherModal__regist_inner} ref={innerRef}>
              {children}
            </div>
          </div>
        </div>
      </dialog>
    </>
  )
}
